import { AppUI } from '@seedlang/state';
import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import styled from '@emotion/styled';
import { remove } from 'lodash';
import Text from 'components/text';
import { isPresent } from '@seedlang/utils';

const Wrapper = styled.div`
  
`;

const ShowEnglishTranslation = styled.div`
  color: #696969;
  font-size: 12px;
  display: flex;
  align-items: center;
  &:hover {
    text-decoration: none;
  }
  i {
    margin-right: 5px;
    font-size: 10px;
  }
`;

@observer
class ExercisePrompt extends React.Component {
  @observable showEnglishTranslations = [];

  get englishTranslation() {
    return this.props.englishTranslation || (
      this.props.exerciseEntry?.promptIsEnglishTranslation
        ? this.props.exerciseEntry.promptForUser(AppUI.user)
        : null
    );
  }

  toggleEnglishTranslation = (exerciseEntry) => {
    if (this.englishTranslationIsToggled(exerciseEntry)) {
      remove(this.showEnglishTranslations, item => item === exerciseEntry.id);
    } else {
      this.showEnglishTranslations.push(exerciseEntry.id);
    }
  }
  englishTranslationIsToggled = (exerciseEntry) => {
    return this.showEnglishTranslations.includes(exerciseEntry.id);
  }

  render() {
    return (
      <Wrapper>
        {
          isPresent(this.englishTranslation) &&
          <ShowEnglishTranslation onClick={() => this.toggleEnglishTranslation(this.props.exerciseEntry)} >
            {this.englishTranslationIsToggled(this.props.exerciseEntry) ? <i className='fa fa-minus' /> : <i className='fa fa-plus' />}
            <span className='underline'>{this.englishTranslationIsToggled(this.props.exerciseEntry) ? 'Hide Translation' : 'Show Translation'}</span>
          </ShowEnglishTranslation>
        }
        {
          isPresent(this.englishTranslation) && this.englishTranslationIsToggled(this.props.exerciseEntry) &&
          <Text onClick={() => this.toggleEnglishTranslation(this.props.exerciseEntry)} style={{marginTop: '5px'}}>
            {this.englishTranslation}
          </Text>
        }
      </Wrapper>
    );
  }
}

export default ExercisePrompt;
